import { useTranslation } from "react-i18next";
import {
  InvisibleInput,
  Tabs,
  useDiscardModal,
} from "senf-atomic-design-system";
import Button from "senf-atomic-design-system/src/components/core/button/Button";
import Dropdown from "senf-atomic-design-system/src/components/core/dropdown/Dropdown";

const Header = ({ title, setTitle, handleDelete, index, setIndex, formik }) => {
  const { t } = useTranslation();
  const { displayDiscardModal } = useDiscardModal();

  return (
    <div className="border-border-subdued z-50 flex h-auto flex-col border-b bg-white p-5 pb-0">
      <div className="flex w-full items-center  justify-between gap-3">
        <h2 className="heading-lg w-full pl-3">
          <InvisibleInput
            size="body-lg-bold"
            value={title}
            onChange={setTitle}
            maxRows={1}
            placeholder={t("global:title")}
          />
        </h2>

        <Dropdown
          variant="shapeless"
          trailingIcon="more"
          closeOnClick={true}
          items={[
            {
              text: t("util:delete", { val: t("global:map") }),
              leadingIcon: "trash",
              critical: true,
              onClick: () =>
                displayDiscardModal({
                  title: t("util:delete", { val: t("global:map") }),
                  description: t("global:deleteDescription"),
                  submitText: t("global:delete"),
                  onSubmit: async () => {
                    handleDelete();
                  },
                }),
            },
          ]}
        />
        <Button
          size="md"
          onClick={() =>
            displayDiscardModal({
              // title: t("dialogMap:add.discardTitle"),
              // description: t("dialogMap:add.discardDescription"),
              // submitText: t("global:discard"),
              onSubmit: async () => {},
            })
          }
          leadingIcon="x-md"
          tooltipLabel={t("global:close")}
        />
      </div>
      <Tabs
        active={index}
        classNames={{ wrapper: "ml-2 h-14" }}
        setActive={setIndex}
        // type="filled"
        tabs={[
          {
            tab: "planningArea",
            text: t("global:planningArea"),
            icon: "area",
          },
          {
            tab: "upload",
            text: t("util:upload", { val: t("global:data") }),
            icon: "share-alt",
            disabled: !formik.values.mapbounds,
          },
          {
            tab: "create",
            text: t("util:insert", { val: t("global:data") }),
            icon: "plus-md",
            disabled: !formik.values.mapbounds,
          },
        ].filter(Boolean)}
      />
    </div>
  );
};

export default Header;
